
import CAStore from "../Store/TemplateStore/template.store"
export const store = CAStore;

export const getAppBaseURL = () => {
  const appName = store.getState().app;
  switch (appName) {
    case "ca":
      return process.env.REACT_APP_URL + "/advisor/api/v1/ca/";
    case "ra":
      return process.env.REACT_APP_URL + "/advisor/api/v1/ra/"
    default:
      return process.env.REACT_APP_URL + "/advisor/api/v1/"
  }
};
